<template>
    <div>
        <!-- Conta Modal -->
        <div class="modal fade" id="contaPacienteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Conta</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="aberto">
                        <div v-show="!id_marcacao">
                            <adiantamento-particular ref="adiant" :view="true" :idpaciente="atendimento.id_paciente" @atendselec="ver_atendimento" />
                        </div>

                        <template v-if="id_marcacao">

                            <div class="alert alert-info d-flex justify-content-between" v-if="selecionado">
                                <div>
                                    <div v-if="atendimento && atendimento.paciente">{{ atendimento.paciente.search }}</div>
                                    <div class="small" v-if="selecionado.marcacao && selecionado.marcacao.medico">{{ selecionado.marcacao.medico.st_nome_exibicao }}</div>
                                    <div class="small">#{{ selecionado.id_atendimento }}</div>
                                    <div class="small">{{ $util.getFormatDate(selecionado.dt_inicio) }}</div>
                                </div>
                                <div>
                                    <a href="#" @click.prevent="id_marcacao = null" class="alert-link">
                                        <i class="fa-solid fa-chevron-left"></i>
                                    </a>
                                </div>
                            </div>
                            
                            <procedimentos
                                class="mb-3"
                                v-if="id_marcacao"
                                ref="proced"
                                :idMarcacao="id_marcacao"
                                :consultorio="true"
                                :conta="true" />

                            <pagamento ref="pagamento" :view="true" />

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
// import ContaPacienteVisualizacao from '../recepcao/ContaPacienteVisualizacao.vue';
import Pagamento from '../recepcao/Pagamento.vue';
import Procedimentos from "../recepcao/Procedimentos.vue";
import AdiantamentoParticular from '../recepcao/AdiantamentoParticular.vue';

export default {
    data() {
        return { 
            id_marcacao: null, 
            pagamentos: null, 
            aberto: false, 
            selecionado: null, 
        }
    },

    components: { 
        // ContaPacienteVisualizacao, 
        Procedimentos, 
        Pagamento,
        AdiantamentoParticular, 
    },

    props: ['atendimento'], 

    methods: { 
        ver_atendimento (atd) { 
            this.selecionado = _.cloneDeep(atd);

            if ( !atd || !atd.marcacao || !atd.marcacao.id_marcacao ) { 
                console.log('atd', atd);

                this.$toast.add({ 
                    severity: "error",
                    summary: 'Recibo',
                    detail: 'Atendimento não identificado.',
                    life: 3000
                });

                return;
            }

            this.id_marcacao = null; 

            this.$nextTick(() => { 
                this.id_marcacao = atd.marcacao.id_marcacao;

                this.$nextTick(() => { 
                    this.$refs.proced.carregar();

                    this.$refs.pagamento.abrir(
                        atd.id_atendimento,
                        () => {
                          // this.abrindo = false;
                        }
                    );
                });
            });
        },

        abrir () { 
            this.id_marcacao = null;
            this.aberto = true; 

            this.$nextTick(() => { 
                $('#contaPacienteModal').modal('show');
            });

            /*

            if ( this.pagamentos === null ) { 

                this.$util.load(this, { 
                    service: 'pagamentos',
                    func: 'index',
                    parms: { 
                        id_paciente: this.atendimento.id_paciente, 
                    },
                    loadTo: res => { 
                        this.pagamentos = res;
                    }
                });

            }

            this.id_marcacao = null;

            this.$nextTick(() => { 
                this.id_marcacao = this.atendimento.marcacao.id_marcacao;

                this.$nextTick(() => { 
                    this.$refs.proced.carregar();

                    this.$refs.pagamento.abrir(
                        this.atendimento.id_atendimento,
                        () => {
                          // this.abrindo = false;
                        }
                    );

                    // this.$refs.conta.load(id_marcacao);

                    $('#contaPacienteModal').modal('show');
                });
            });
            */
        }
    }
}
</script>
